import { reemaColors } from '@act/storybook';
import {
  Box,
  Button,
  Card,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import LearnMoreDialogContent from 'react-components/dialog-forms/LearnMoreDialogContent';
import { DialogHeader } from 'react-components/dialog/dialog-header';
import { learnMoreCreatorSelectors } from 'redux/slices/learnMoreCreatorSlice';
import { surveyCreatorSelectors } from 'redux/slices/surveyCreatorSlice';
import CloseIcon from '@mui/icons-material/Close';
import {
  LearnMoreContentDto,
  SurveyV2,
  UserDto,
} from '@act/shared/data-transfer-objects';
import SurveyDialogMock from './survey-dialog-mock/SurveyStepperPreview';

const PREVIEW_MEMBER: Partial<UserDto> = {
  id: 'preview-user',
  firstName: 'Mickey',
  lastName: 'MacDowell',
  email: 'preview@example.com',
};

interface LivePreviewProps {
  previewType: 'learnMore' | 'survey';
}

const LivePreview = ({ previewType }: LivePreviewProps) => {
  const content =
    previewType === 'learnMore'
      ? learnMoreCreatorSelectors.useSelectLearnMoreCurrentContent()
      : surveyCreatorSelectors.useSelectSurveyCreatorCurrentContent();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        boxSizing: 'border-box',
        backgroundColor: reemaColors.lightBackground,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
          width: '100%',
        }}
      >
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            position: 'relative',
            width: '600px',
            margin: '0 auto',
          }}
        >
          <DialogHeader
            postfixAction={{
              title: 'close',
              callback: () => {},
              icon: <CloseIcon />,
            }}
          >
            {previewType === 'learnMore'
              ? `Learn more - ${
                  (content as LearnMoreContentDto)?.title || 'Content missing'
                }`
              : `Survey for ${
                  PREVIEW_MEMBER.firstName
                } ${PREVIEW_MEMBER.lastName.charAt(0)}`}
          </DialogHeader>
          <Box
            sx={{
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <DialogContent
              sx={{
                width: '100%',
                padding: '20px 24px 42px',
                margin: '0 auto',
                boxSizing: 'border-box',
              }}
            >
              <DialogContentText component="div">
                {previewType === 'learnMore' ? (
                  <LearnMoreDialogContent
                    learnMoreContent={content as LearnMoreContentDto}
                  />
                ) : (
                  <SurveyDialogMock
                    content={content as SurveyV2.CreateSurveyJSONDto}
                    member={PREVIEW_MEMBER}
                  />
                )}
              </DialogContentText>
            </DialogContent>
          </Box>
          <DialogActions
            sx={{
              padding: '16px 24px 8px',
              margin: 'auto 0 8px',
              borderTop: '1px solid #dce4e8',
            }}
          >
            <Button
              variant="contained"
              type="button"
              onClick={() => {}}
              sx={{ padding: '8px 32px' }}
            >
              Close
            </Button>
          </DialogActions>
        </Card>
      </Box>
    </Box>
  );
};

export default LivePreview;
